// extracted by mini-css-extract-plugin
module.exports = {"active-page":"PageButton_active-page__OQbYo","page":"PageButton_page__3oJbT","previous":"PageButton_previous__ro2QP","next":"PageButton_next__2LJRf"};